import { environment } from '../../environments/environment';

export const servicesUrl = {
  // Donnees :
  donneesHistorique: ({ profondeurMois, idDonnees }) =>
    `${environment.apis.API_CRT_IOT}/v2/donnees/historiques?range=0-${profondeurMois}&idDonnees=${idDonnees}`,
  getDonneesById: ({ idDonnee }) => `${environment.apis.API_CRT_IOT}/v3/donnees?idDonnees=${idDonnee}`,
  getDonneesBySite: ({ idSite }) => `${environment.apis.API_CRT_IOT}/v2/sites/${idSite}/donnees`,

  getSiteActiveAlarms: ({ siteId, langue, nbJours, limite }) =>
    `${environment.apis.API_CRT_IOT}/v2/donnees/fastget/JSON/alarmes?siteId=${siteId}&langue=${langue}&nbJours=${nbJours}&limite=${limite}`,
  getSiteEvenements: ({ idSite, nbJours, maxEvent, debutFinComm, isTriParDate, isActif }) =>
    `${environment.apis.API_CRT_IOT}/v3/donnees/${idSite}/evenements?nbJours=${nbJours}&range=0-${maxEvent}&comm=${debutFinComm}&isTriParDate=${isTriParDate}&isActif=${isActif}`,

  //Documents
  getDocuments: ({ type, nomFichier }) => `${environment.apis.API_CRT_IOT}/v1/documents/distant/${type}/${nomFichier}`,

  //Favoris Vue synthetique
  getFavoris: `${environment.apis.API_CRT_IOT}/v2/vue-synthetiques/favoris`,
  getFavorisByIdSite: ({ idSite }) => `${environment.apis.API_CRT_IOT}/v2/vue-synthetiques/favoris?idSite=${idSite}`,

  //Historique
  getSiteHistorique: ({ idSite, nbJours }) =>
    `${environment.apis.API_CRT_IOT}/v2/sites/${idSite}/historiques?range=0-${nbJours}`,

  // Groupe Historique
  groupesHistoriques: {
    postGroupeHistorique: `${environment.apis.API_CRT_IOT}/v2/groupes-historiques`,
    putGroupeHistorique: `${environment.apis.API_CRT_IOT}/v2/groupes-historiques`,
    getGroupesHistoriquesByIdSite: ({ idSite }) =>
      `${environment.apis.API_CRT_IOT}/v2/groupes-historiques?idSite=${idSite}`,
    getHistoricGroupByIdFromApi: ({ groupId, idSite }) =>
      `${environment.apis.API_CRT_IOT}/v2/groupes-historiques/${groupId}?idSite=${idSite}`,
    deleteHistoricGroupByIdFromApi: ({ groupId }) =>
      `${environment.apis.API_CRT_IOT}/v2/groupes-historiques/${groupId}`,
  },

  //Loi regulation
  getLoiRegulationBySite: ({ idSite }) =>
    `${environment.apis.API_CRT_IOT}/v2/sites/${idSite}/loi-regulations?types=LOI_GENERIQUE_CONSIGNE,LOI_GENERIQUE_COURBE`,

  //PH
  getPhByIdSite: ({ idSite }) => `${environment.apis.API_CRT_IOT}/v2/sites/${idSite}/programme-horaires/infos`,
  getPhByIdSiteAndDate: ({ idSite, dateIsoDebut, dateIsoFin }) =>
    `${environment.apis.API_CRT_IOT}/v2/sites/${idSite}/programme-horaires?dateDebut=${dateIsoDebut}&dateFin=${dateIsoFin}`,
  getPhByIdAndDate: ({ phId, dateIsoDebut, dateIsoFin }) =>
    `${environment.apis.API_CRT_IOT}/v2/programme-horaires/${phId}?dateDebut=${dateIsoDebut}&dateFin=${dateIsoFin}`,
  sendPh: () => `${environment.apis.API_CRT_IOT}/v2/programme-horaires/send`,

  //Site
  getSiteByIdSite: ({ idSite }) => `${environment.apis.API_CRT_IOT}/v2/sites/${idSite}`,
  getSiteIdByDkCode: (dkCode: string) =>
    `${environment.apis.API_CRT_IOT}/v2/sites/fastget/JSON/site-dkcode-to-id?dkCodeSite=${dkCode}`,
  getSiteInPerimetre: `${environment.apis.API_CRT_IOT}/v2/sites/perimetre`,
  searchSite: `${environment.apis.API_CRT_IOT}/v2/sites/search`,

  siteFavoris: {
    getAllFavoris: `${environment.apis.API_CRT_IOT}/v2/favoris`,
    putFavoris: ({ dkCodeSite }) => `${environment.apis.API_CRT_IOT}/v2/favoris/${dkCodeSite}`,
    deleteFavoris: ({ dkCodeSite }) => `${environment.apis.API_CRT_IOT}/v2/favoris/${dkCodeSite}`,
  },

  utilisateurs: {
    getCRTRights: `${environment.apis.API_CRT_IOT}/v2/utilisateurs/me`,
  },

  // blocage
  mesBlocages: `${environment.apis.API_CRT_IOT}/v2/donnees/fastget/JSON/mesBlocagesMobilite`,
  updateBlocageDonnee: `${environment.apis.API_CRT_IOT}/v2/donnees/blocage`,
  updateBlocageSite: ({ idSite }) => `${environment.apis.API_CRT_IOT}/v2/sites/${idSite}/blocage`,

  journal: {
    getReglageCRT: ({ idDonnee }) =>
      `${environment.apis.API_CRT_IOT}/v2/journal/fastget/JSON/reglagesCrt?idDonnee=${idDonnee}`,
  },

  bandeauDeCom: {
    sendCommunication: `${environment.apis.API_CRT_IOT}/v2/sdd/demandeCom`,
    getCommunicationStatus: ({ idSite }) =>
      `${environment.apis.API_CRT_IOT}/v2/sdd/fastget/JSON/suiviCommunication?idSite=${idSite}`,
    getCommunicationStatusByIdMetier: ({ idSite, idMetier }) =>
      `${environment.apis.API_CRT_IOT}/v2/sdd/fastget/JSON/suiviCommunication?idSite=${idSite}&idOm=${idMetier}`,
  },
};
